/** MHV Consignment Page JS - commission calculator + consignment inquiry form.
 *  Depends on: mhv-config.js.
 *  The "Your Consignments" dashboard that used to live here (and on the page) is
 *  the account page's (mhv-account-consignments.js); /pages/consignment just links
 *  to /account#my-consignments-section. The page's sections are always open — there
 *  is no accordion to toggle. */

(function() {
  'use strict';

  // ============================================================
  // Commission Calculator
  // ============================================================
  var COMMISSION_BRACKETS = [
    { limit: 10,    rate: 0.50 },
    { limit: 100,   rate: 0.40 },
    { limit: 250,   rate: 0.35 },
    { limit: 500,   rate: 0.30 },
    { limit: 1000,  rate: 0.25 },
    { limit: 2500,  rate: 0.20 },
    { limit: 5000,  rate: 0.15 },
    { limit: Infinity, rate: 0.10 }
  ];

  // LOG-79 — the ladder above is only a FALLBACK. The authoritative brackets live in
  // backend lib/commission.js; fetch the built-in "auto" (standard consignor) rate so a
  // server-side rate change reflects in this estimate without editing the theme. On any
  // failure the hard-coded fallback keeps the calculator working.
  (function loadServerBrackets() {
    try {
      fetch(MHV.SERVER_URL + '/api/commission-rates/public')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(d) {
          var rates = d && d.rates;
          if (!rates || !rates.length) return;
          var auto = rates.filter(function(x) { return x.name === 'auto'; })[0] || rates[0];
          if (!auto || !auto.brackets || !auto.brackets.length) return;
          COMMISSION_BRACKETS = auto.brackets.map(function(b) {
            return { limit: (b.upTo == null ? Infinity : b.upTo), rate: b.rate };
          });
        })
        .catch(function() {});
    } catch (e) {}
  })();

  function calculateCommission(hammerPrice) {
    var remaining = hammerPrice;
    var totalCommission = 0;
    var prevLimit = 0;
    var rows = [];

    for (var i = 0; i < COMMISSION_BRACKETS.length; i++) {
      if (remaining <= 0) break;
      var bracket = COMMISSION_BRACKETS[i];
      var bracketSize = bracket.limit === Infinity ? remaining : bracket.limit - prevLimit;
      var taxable = Math.min(remaining, bracketSize);
      var commission = taxable * bracket.rate;
      totalCommission += commission;
      rows.push({
        rate: Math.round(bracket.rate * 100) + '%',
        amount: taxable,
        commission: commission,
        label: bracket.limit === Infinity
          ? 'of remaining $' + taxable.toFixed(2)
          : (prevLimit === 0 ? 'of first $' + taxable.toFixed(2) : 'of next $' + taxable.toFixed(2))
      });
      remaining -= taxable;
      prevLimit = bracket.limit;
    }

    return {
      commission: totalCommission,
      payout: hammerPrice - totalCommission,
      rows: rows,
      effectiveRate: hammerPrice > 0 ? (totalCommission / hammerPrice * 100) : 0
    };
  }

  function initCommissionCalculator() {
    var input = document.getElementById('calc-hammer-price');
    if (!input) return;

    var resultsDiv = document.getElementById('calc-results');
    var breakdownDiv = document.getElementById('calc-breakdown');
    var commissionEl = document.getElementById('calc-commission');
    var payoutEl = document.getElementById('calc-payout');
    var effectiveEl = document.getElementById('calc-effective-pct');

    var debounceTimer;
    input.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        var price = parseFloat(input.value);
        if (!price || price <= 0) {
          resultsDiv.style.display = 'none';
          return;
        }

        var result = calculateCommission(price);

        // Build breakdown rows
        var html = '';
        for (var i = 0; i < result.rows.length; i++) {
          var row = result.rows[i];
          html += '<div class="calc-breakdown-row"><span>' + row.rate + ' ' + row.label + '</span><span>$' + row.commission.toFixed(2) + '</span></div>';
        }
        breakdownDiv.innerHTML = html;

        commissionEl.textContent = '$' + result.commission.toFixed(2);
        payoutEl.textContent = '$' + result.payout.toFixed(2);
        effectiveEl.textContent = result.effectiveRate.toFixed(1) + '%';

        resultsDiv.style.display = 'block';
      }, 150);
    });
  }

  // Pre-fill form fields if customer data is available via data attributes on the form
  // The Liquid template sets: data-customer-name, data-customer-email, data-customer-phone
  // on the <form id="consignment-contact-form"> element.
  document.addEventListener('DOMContentLoaded', function() {
    initCommissionCalculator();

    var form = document.getElementById('consignment-contact-form');
    if (!form) return;

    var customerName = form.dataset.customerName;
    var customerEmail = form.dataset.customerEmail;
    var customerPhone = form.dataset.customerPhone;

    if (customerName) {
      var nameField = document.getElementById('consign-name');
      if (nameField && !nameField.value) {
        nameField.value = customerName;
      }
    }

    if (customerEmail) {
      var emailField = document.getElementById('consign-email');
      if (emailField && !emailField.value) {
        emailField.value = customerEmail;
        // Trigger validation for pre-filled email
        setTimeout(function() { validateEmail(emailField); }, 100);
      }
    }

    if (customerPhone) {
      var phoneField = document.getElementById('consign-phone');
      if (phoneField && !phoneField.value) {
        // Format the phone number before setting
        var rawPhone = customerPhone.replace(/\D/g, '');
        if (rawPhone.length >= 10) {
          var digits = rawPhone.slice(-10); // Take last 10 digits
          phoneField.value = '(' + digits.slice(0,3) + ') ' + digits.slice(3,6) + '-' + digits.slice(6,10);
        }
      }
    }
  });

  // Phone number formatting - numbers only with (XXX) XXX-XXXX format
  (function() {
    var phoneInput = document.getElementById('consign-phone');
    var phoneError = document.getElementById('phone-error');

    if (phoneInput) {
      phoneInput.addEventListener('input', function(e) {
        // Get only digits
        var digits = this.value.replace(/\D/g, '');

        // Limit to 10 digits
        digits = digits.slice(0, 10);

        // Format as (XXX) XXX-XXXX
        var formatted = '';
        if (digits.length > 0) {
          formatted = '(' + digits.slice(0, 3);
          if (digits.length >= 3) {
            formatted += ') ';
            if (digits.length > 3) {
              formatted += digits.slice(3, 6);
              if (digits.length >= 6) {
                formatted += '-';
                if (digits.length > 6) {
                  formatted += digits.slice(6, 10);
                }
              }
            }
          }
        }

        this.value = formatted;

        // Validate (phone is optional, but if entered must be valid)
        if (digits.length > 0 && digits.length < 10) {
          phoneError.style.display = 'block';
          this.classList.add('cf-invalid');
          this.classList.remove('cf-valid');
        } else {
          phoneError.style.display = 'none';
          this.classList.remove('cf-invalid');
          if (digits.length === 10) {
            this.classList.add('cf-valid');
          } else {
            this.classList.remove('cf-valid');
          }
        }
      });

      // Prevent pasting non-numeric characters
      phoneInput.addEventListener('paste', function(e) {
        e.preventDefault();
        var pastedData = (e.clipboardData || window.clipboardData).getData('text');
        var digits = pastedData.replace(/\D/g, '').slice(0, 10);

        // Trigger input event with cleaned data
        this.value = digits;
        this.dispatchEvent(new Event('input'));
      });
    }
  })();

  // Real-time email validation
  function validateEmail(input) {
    var emailError = document.getElementById('email-error');
    var email = input.value.trim();
    var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (email.length === 0) {
      emailError.style.display = 'none';
      input.classList.remove('cf-invalid', 'cf-valid');
      return false;
    }

    if (!emailPattern.test(email)) {
      emailError.style.display = 'block';
      input.classList.add('cf-invalid');
      input.classList.remove('cf-valid');
      return false;
    } else {
      emailError.style.display = 'none';
      input.classList.remove('cf-invalid');
      input.classList.add('cf-valid');
      return true;
    }
  }

  (function() {
    var emailInput = document.getElementById('consign-email');
    if (emailInput) {
      emailInput.addEventListener('blur', function() {
        validateEmail(this);
      });
      emailInput.addEventListener('input', function() {
        // Only validate on input if already marked invalid
        if (this.classList.contains('cf-invalid')) {
          validateEmail(this);
        }
      });
    }
  })();

  // Multi-image upload handling (up to 5 images)
  var MAX_IMAGES = 5;
  var MAX_SIZE = 5 * 1024 * 1024; // 5MB per image
  var selectedImages = []; // Array of {data: base64, filename: string, size: number}

  (function() {
    var fileInput = document.getElementById('consign-images');
    var dropzone = document.getElementById('cf-dropzone');
    var previewsContainer = document.getElementById('cf-previews');
    var uploadCount = document.getElementById('cf-upload-count');
    var countSpan = document.getElementById('cf-count');

    if (!fileInput) return;

    var validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];

    function formatFileSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    function updateUI() {
      // Update count
      countSpan.textContent = selectedImages.length;
      uploadCount.style.display = selectedImages.length > 0 ? 'block' : 'none';

      // Update dropzone state
      if (selectedImages.length > 0) {
        dropzone.classList.add('cf-has-files');
      } else {
        dropzone.classList.remove('cf-has-files');
      }

      // Update dropzone text if max reached
      var uploadText = dropzone.querySelector('.cf-upload-text');
      if (selectedImages.length >= MAX_IMAGES) {
        uploadText.innerHTML = '<strong>Maximum photos reached</strong>';
        dropzone.style.pointerEvents = 'none';
        dropzone.style.opacity = '0.6';
      } else {
        uploadText.innerHTML = '<strong>Click to upload</strong> or drag and drop';
        dropzone.style.pointerEvents = '';
        dropzone.style.opacity = '';
      }

      // Render previews
      previewsContainer.innerHTML = '';
      selectedImages.forEach(function(img, index) {
        var item = document.createElement('div');
        item.className = 'cf-preview-item';
        item.innerHTML =
          '<img src="' + img.data + '" alt="Preview ' + (index + 1) + '" class="cf-preview-img">' +
          '<button type="button" class="cf-preview-remove" data-index="' + index + '">\u00d7</button>' +
          '<div class="cf-preview-info">' + formatFileSize(img.size) + '</div>';
        previewsContainer.appendChild(item);
      });
    }

    function addFiles(files) {
      var fileArray = Array.from(files);
      var added = 0;
      var skipped = 0;

      fileArray.forEach(function(file) {
        if (selectedImages.length >= MAX_IMAGES) {
          skipped++;
          return;
        }

        if (!validTypes.includes(file.type)) {
          MHV.toast('"' + file.name + '" is not a valid image type. Please use JPEG, PNG, GIF, or WebP.', { type: 'error' });
          return;
        }

        if (file.size > MAX_SIZE) {
          MHV.toast('"' + file.name + '" is too large (' + formatFileSize(file.size) + '). Maximum size is 2MB.', { type: 'error' });
          return;
        }

        var reader = new FileReader();
        reader.onload = function(e) {
          selectedImages.push({
            data: e.target.result,
            filename: file.name,
            size: file.size
          });
          added++;
          updateUI();
        };
        reader.readAsDataURL(file);
      });

      if (skipped > 0) {
        MHV.toast('Only ' + MAX_IMAGES + ' images allowed. ' + skipped + ' file(s) were not added.', { type: 'warning' });
      }
    }

    function removeImage(index) {
      selectedImages.splice(index, 1);
      updateUI();
    }

    // File input change
    fileInput.addEventListener('change', function(e) {
      addFiles(e.target.files);
      fileInput.value = ''; // Reset so same file can be selected again
    });

    // Drag and drop
    dropzone.addEventListener('dragover', function(e) {
      e.preventDefault();
      if (selectedImages.length < MAX_IMAGES) {
        this.classList.add('cf-drag-over');
      }
    });

    dropzone.addEventListener('dragleave', function(e) {
      e.preventDefault();
      this.classList.remove('cf-drag-over');
    });

    dropzone.addEventListener('drop', function(e) {
      e.preventDefault();
      this.classList.remove('cf-drag-over');
      if (selectedImages.length < MAX_IMAGES) {
        addFiles(e.dataTransfer.files);
      }
    });

    // Remove button clicks (event delegation)
    previewsContainer.addEventListener('click', function(e) {
      if (e.target.classList.contains('cf-preview-remove')) {
        var index = parseInt(e.target.dataset.index, 10);
        removeImage(index);
      }
    });

    // Expose for form reset
    window.resetConsignmentImages = function() {
      selectedImages = [];
      updateUI();
    };
  })();

  // Invisible reCAPTCHA for consignment form
  var consignmentRecaptchaWidgetId;

  // These MUST remain global — referenced by reCAPTCHA script onload parameter
  window.onConsignmentRecaptchaLoad = function() {
    consignmentRecaptchaWidgetId = grecaptcha.render('consignment-recaptcha-container', {
      'sitekey': '6LcpeCcsAAAAAGf901IXNiiXJf_L-1b3C-dYxs0c',
      'size': 'invisible',
      'callback': window.onConsignmentRecaptchaSuccess,
      'error-callback': window.onConsignmentRecaptchaError
    });
  };

  window.onConsignmentRecaptchaSuccess = function(token) {
    submitConsignmentForm(token);
  };

  window.onConsignmentRecaptchaError = function() {
    showFormResponse('error', 'reCAPTCHA error. Please refresh the page and try again.');
    resetSubmitButton();
  };

  function showFormResponse(type, message) {
    var responseDiv = document.getElementById('consignment-form-response');
    var iconSpan = responseDiv.querySelector('.cf-response-icon');
    var textSpan = responseDiv.querySelector('.cf-response-text');

    responseDiv.className = 'cf-response cf-' + type;
    iconSpan.textContent = type === 'success' ? '\u2713' : '\u2715';
    textSpan.textContent = message;
    responseDiv.style.display = 'flex';

    // Scroll to response
    responseDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function resetSubmitButton() {
    var btn = document.getElementById('consign-submit-btn');
    btn.disabled = false;
    btn.classList.remove('cf-loading');
  }

  // Form submission
  var formEl = document.getElementById('consignment-contact-form');
  if (formEl) {
    formEl.addEventListener('submit', function(e) {
      e.preventDefault();

      // Hide any previous response
      document.getElementById('consignment-form-response').style.display = 'none';

      // Validate email
      var emailInput = document.getElementById('consign-email');
      var email = emailInput.value.trim();
      var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(email)) {
        showFormResponse('error', 'Please enter a valid email address.');
        emailInput.classList.add('cf-invalid');
        document.getElementById('email-error').style.display = 'block';
        emailInput.focus();
        return;
      }

      // Validate phone (optional, but if entered must be 10 digits)
      var phoneInput = document.getElementById('consign-phone');
      var phoneDigits = phoneInput.value.replace(/\D/g, '');
      if (phoneDigits.length > 0 && phoneDigits.length < 10) {
        showFormResponse('error', 'Please enter a valid 10-digit phone number or leave it blank.');
        phoneInput.classList.add('cf-invalid');
        document.getElementById('phone-error').style.display = 'block';
        phoneInput.focus();
        return;
      }

      // Show loading state
      var btn = document.getElementById('consign-submit-btn');
      btn.disabled = true;
      btn.classList.add('cf-loading');

      // Execute invisible reCAPTCHA
      grecaptcha.execute(consignmentRecaptchaWidgetId);
    });
  }

  async function submitConsignmentForm(recaptchaToken) {
    var formData = {
      name: document.getElementById('consign-name').value,
      email: document.getElementById('consign-email').value,
      phone: document.getElementById('consign-phone').value,
      message: document.getElementById('consign-message').value,
      recaptcha_token: recaptchaToken,
      form_type: 'consignment_inquiry'
    };

    // Add images if selected (send first image as primary, rest as array)
    if (selectedImages.length > 0) {
      formData.image = selectedImages[0].data;
      formData.image_filename = selectedImages[0].filename;

      // Send additional images as array
      if (selectedImages.length > 1) {
        formData.additional_images = selectedImages.slice(1).map(function(img) {
          return {
            data: img.data,
            filename: img.filename
          };
        });
      }
    }

    try {
      var response = await fetch(MHV.SERVER_URL + '/contact-form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        var result = await response.json();
        showFormResponse('success', result.message || 'Thank you for your inquiry! We will be in touch shortly.');
        document.getElementById('consignment-contact-form').reset();

        // Reset image previews
        if (window.resetConsignmentImages) {
          window.resetConsignmentImages();
        }
      } else {
        var result = await response.json();
        showFormResponse('error', result.error || 'An error occurred. Please try again or email us directly at consign@graniteunionauction.com');
        grecaptcha.reset(consignmentRecaptchaWidgetId);
      }
    } catch (error) {
      console.error('Error:', error);
      showFormResponse('error', 'An error occurred. Please try again or email us directly at consign@graniteunionauction.com');
      grecaptcha.reset(consignmentRecaptchaWidgetId);
    }

    resetSubmitButton();
  }

})();
